import { render, staticRenderFns } from "./MaterialDelivery.vue?vue&type=template&id=2dc21ba6&scoped=true&"
import script from "./MaterialDelivery.vue?vue&type=script&lang=js&"
export * from "./MaterialDelivery.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDelivery.vue?vue&type=style&index=0&id=2dc21ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc21ba6",
  null
  
)

export default component.exports